import { FC, SelectHTMLAttributes } from 'react';
import Stack from '@/shared/components/Stack/Stack';
import './Select.css';
interface Option {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
}

const Select: FC<SelectProps> = ({
  options,
  className = '',
  ...props
}) => {
  return (
    <Stack className="select-wrapper" direction="horizontal" align="center">
      <select
        className={`select ${className}`}
        {...props}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
          </option>
        ))}
      </select>
    </Stack>
  );
};

export default Select; 